import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_STORAGE_ENCRYPTION_KEY || 
  'default-key-change-in-production'; // MUST be set in production

/**
 * Secure storage utility for encrypting sensitive data in localStorage
 * Provides encryption/decryption for tokens and other sensitive information
 */
// eslint-disable-next-line import/prefer-default-export
export const secureStorage = {
  /**
   * Store encrypted value in localStorage
   * @param {string} key - Storage key
   * @param {any} value - Value to encrypt and store
   */
  setItem(key, value) {
    try {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        ENCRYPTION_KEY
      ).toString();
      localStorage.setItem(key, encrypted);
    } catch (error) {
      console.error('Encryption error:', error);
      throw new Error('Failed to store secure data');
    }
  },
  
  /**
   * Retrieve and decrypt value from localStorage
   * @param {string} key - Storage key
   * @returns {any|null} Decrypted value or null if not found
   */
  getItem(key) {
    try {
      const encrypted = localStorage.getItem(key);
      if (!encrypted) return null;
      
      const decrypted = CryptoJS.AES.decrypt(encrypted, ENCRYPTION_KEY);
      const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
      
      if (!decryptedStr) {
        // Handle legacy unencrypted tokens during migration
        // Try to parse as plain text (for backward compatibility)
        try {
          return encrypted;
        } catch {
          return null;
        }
      }
      
      return JSON.parse(decryptedStr);
    } catch (error) {
      console.error('Decryption error:', error);
      // Fallback to plain text for migration period
      try {
        return localStorage.getItem(key);
      } catch {
        return null;
      }
    }
  },
  
  /**
   * Remove item from localStorage
   * @param {string} key - Storage key
   */
  removeItem(key) {
    localStorage.removeItem(key);
  },
  
  /**
   * Clear all items from localStorage
   */
  clear() {
    localStorage.clear();
  }
};
